const ROUTE_BASE = '/account';

export const FROM_UPGRADE_PLAN_QUERY = 'fromUpgrade';

export const BILLING_ROUTES = {
  coupons: `${ROUTE_BASE}/coupon`,
  plans: `${ROUTE_BASE}/plans`,
  plansFromUpgrade: `${ROUTE_BASE}/plans?${FROM_UPGRADE_PLAN_QUERY}`,
};
